module.exports = __webpack_public_path__ + "static/media/Automated flight tracking assistance.fb326da4.png";